<template>
  <div class="popup" ref="popupBox" style="display: none">
    <div v-if="type === 'center'" class="popup-main" :class="show?'fadeIn': 'fadeOut'">
      <div class="container">
       <slot></slot>
      </div>
      <div v-if="hasClose" class="closeBox">
        <div class="dis-inline-block closeIcon" @click="hidePopup"></div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'popup',
  props: {
    imgUrl: String,
    hasClose: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'center'
    }
  },
  data () {
    return {
      show: false,
      timer: null,
      touchTime: 0
    }
  },
  methods: {
    showPopup () {
      // 先关闭原有的，防止多个弹窗同时出现
      // this.show = false
      // this.$refs.popupBox.style.display = 'none'

      this.show = true
      this.$refs.popupBox.style.display = 'block'
    },
    hidePopup () {
      var that = this
      this.show = false
      this.$emit('cancelAction')
      let timer = setTimeout(function () {
        that.$refs.popupBox.style.display = 'none'
        timer = null
        clearTimeout(timer)
      }, 100)
    }
  },
  
  beforeCreate () {
    console.log("----------进入了popup的beforeCrreate----------------");
  },
  created() {
    console.log("----------进入了popup的created----------------");
  },
  beforeMount() {
    console.log("----------进入了popup的beforeMount----------------");
  },
  mounted() {
    console.log("-------进入了popup的mounted-----------------------");
  },
  beforeActive () {
    console.log("-------进入了popup的beforeActive-----------------------");
  },
  activied () {
    console.log("-------进入了popup的activied-----------------------");
  },
  beforeUpdate () {
    console.log("-------进入了popup的beforeUpdate-----------------------");
  },
  updated () {
    console.log("-------进入了popup的updated-----------------------");
  },
  beforeDestory () {
    console.log("-------进入了popup的beforeDestory-----------------------");
  },
  destoried () {
    console.log("-------进入了popup的destoried-----------------------");
  }
}
</script>

<style lang="less" scoped>
  @import '../style/common.less';
  .popup{
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.7);
    pointer-events: auto;
  }
  .popup-main{
    position: relative;
    height:100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .popup-bottom{
    width: 100%;
  }
  .container{
    max-width: 7.1rem;
    overflow-x: hidden;
  }
  .closeBox{
    // margin-top: .4rem;
    margin-top: .2rem;
    .closeIcon{
      height: .5rem;
      width: .5rem;
      background-repeat: no-repeat;
      background-size: cover;
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABFUExURf///////////////////////////0dwTP///////////////////////////////////////////////////////////5qHap4AAAAXdFJOU5mUDwSOCHAAhxOEP0c2W1QKK3ZDIGIaP3c9IAAAAkFJREFUSA2dVteigyAMDQ5Q3KP+/6feEzba2l59aBk5JDkZQOryzcModSWo0nIc5su2otNS20lBySdk155Eckg7Ommh5ao9dsxBKWSejNDaH7U9uD76lc8QU2pfAlkq7DZdkdtRdA2WqyWuRkjPO1sZt/yo3Pis3k+D++ULy6MzKOy6wTxh8+VPc1pq2CyGs2icD8CsDuMg0FHtUeI62mHcyy5bCPxociYvoBYsWH8MZIHaWx18wA4hwxtDZoTjxg+vEP6IGROGgI/Jr9/9OzlACmQgo79+c0UCHgMCtrYgvmzn6G8x8BtCx5BWUOOjpEBETh2IEgFTgrUWEEC7oISzJsUwtYkNHcuSkkTRlplFIsYgmrhdEElFYHgNSpSyQi6s2cQIreCZwHZMUiwnYsnQHwrDB0IdHn7B/AfBMEi2D3BGcOWU8k70HULVcIY0ieSURE9OhJcRAFSk/TT8GwUZdWGLAQK0XT6LiWRHAQkAqi0u+NFnCFh+YtgD9x+Q/CCUDxLmQVrmyc9FdEn+mFA2+fMS486TRtAEKFSlciXWEulQyKUmnfVAYJrQS3whK3AW20W5B7hNhXqJRYmaR5NFh0G/+L0pAQ/Ig9an0NJ+bLDGGtbC3Ut8b+PIesOdgZToAlVGlHU9/WW6e0ONgZgm29zquVxJqvx28cGq1WWB06Jqvl6z6z2x6u31in1ux/+6xIEZwPX/ngq4AG8eJEkaeV+s5QV7xJ/Qq/zl2cOwYjs/rrZzwHItRpd7wolPT7g/0lVANp//rhwAAAAASUVORK5CYII=');
    }
  }
  // 中间弹出
  .fadeIn{
    animation: fadeIn 0.15s ease;
  }
  .fadeOut{
    animation: fadeOut 0.15s ease;
  }
  @keyframes fadeIn{
    0% { transform: scale(0.7); opacity: 0; }
    100% { transform:scale(1); opacity: 1; }
  }
  @keyframes fadeOut{
    0% { transform: scale(1); opacity: 1; }
    100% { transform:scale(0.5); opacity: 0; }
  }

  // 底部弹出
  .bottomIn{
    animation: bottomIn 0.15s ease;
  }
  .bottomOut{
    animation: bottomOut 0.15s ease;
  }
  @keyframes bottomIn{
    0% { transform: translateY(100%); opacity: 0; }
    100% { transform: translateY(0); opacity: 1; }
  }
  @keyframes bottomOut{
    0% { transform: translateY(0); opacity: 1; }
    100% { transform: translateY(100%); opacity: 0; }
  }
</style>
